module.exports = __webpack_public_path__ + "img/bs-logo.svg";